<template>
<div class="mt-5">
  <div class="modalWrap" v-if="videoModal">
    <div class="videoWrap" style="position:relative">
      <span class="close" @click="videoModal = false">x</span>
      <video-player class="video-player-box" ref="videoPlayer" :options="playerOptions" :playsinline="true" customEventName="customstatechangedeventname">
      </video-player>
    </div>
  </div>
  <div class="alertWrap" v-if="showAlert" style="z-index:-1">
    <div class="alert">
      <h2 class="modalTitle tit1 text-center mb-0">GCASH</h2>
      <label class="my-2" for style="font-size:14px">Please Enter Your Gcash Number</label>
      <div class="wallet_name m-0 noIcon">
        <input class v-model="user_name" type="text" placeholder="Please Enter Your Gcash Number" />
        <div class="icon">
          <div class="icon_bg">
            <i class="fa fas fa-user"></i>
          </div>
        </div>
      </div>
      <p class="text-danger text-center mt-2" style="font-size:14px">Enter the correct phone number,<br> Otherwise you cannot deposit</p>
      <p class="text-danger text-center" style="font-size:14px">Example:09123456789</p>
      <p class="text-center clickMov" @click="videoModal = true">
        [Click to View Deposit Support]
      </p>
      <button class="btn" :disabled="disabledBtn" @click="sendOrder">Submit</button>
    </div>
  </div>
  <div class="flex-column justify-content-start align-items-center" v-if="timeMsg == ''">
  </div>
  <div v-else class="timeMsg">
    <h4 class="tit1" style="color:#007bff !important">{{timeMsg}}</h4>
  </div>
</div>
</template>

<style lang="scss" scoped>
.m-message-container.is-top-center {
  z-index: 9999 !important;
}

.m-message {
  z-index: 9999 !important;
}

.m-message-container {
  z-index: 9999 !important;
}

.allWrap {
  // background-color: #fff;
}

.alertWrap {
  position: fixed;
  z-index: 90;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .alert {
    width: 345px;
    box-shadow: 0 0 3px 3px rgba(0, 0, 0, .6);
    height: 345px;
    background-color: white;
    border-radius: 5px;
  }
}
</style>

<script>
import axios from "axios";
import 'video.js/dist/video-js.css'
import {
  videoPlayer
} from 'vue-video-player'
export default {
  components: {
    videoPlayer
  },
  data() {
    return {
      videoModal: false,
      order: "",
      timeout: "",
      timeMsg: "",
      showAlert: true,
      user_name: "",
      playerOptions: {
        // videojs options
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/gcashMoive.mp4"
        }],
      }
    };
  },
  computed: {
    disabledBtn() {
      return this.$store.state.isLoading
    }
  },
  methods: {
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          let code = res.data.code;
          let type = {
            '20005': 'The order is not exists', // The order is not exists.
            '20012': "The order is expired.", //  The order is not expired.
            '20013': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20000': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20014': "The order is completed.", // The order is completed.
          }
          if (res.data.code == 0) {
            this.order = res.data.data;
            if (res.data.data.user_name && res.data.data.view_url && res.data.data.view_url.indexOf(location.origin) == -1) {
              location.href = res.data.data.view_url
            }
          } else {
            this.$message({
              type: 'error',
              message: type[code],
              closable:true
            })
            this.timeMsg = type[code];
            this.showAlert = false
            clearInterval(this.timeout);
          }
        });
    },
    sendOrder() {
      let user_name = this.user_name;
      if (this.user_name.length != 11 && this.user_name.length != 10) {
        this.$message({
          type: 'error',
          message: 'Please check your phone number',
          closable:true
        })
        return
      }
      if (this.user_name.length == 10) {
        if (this.user_name[0] == 0) {
          this.$message({
            type: 'error',
            message: 'Please check your phone number',
            closable:true
          })
          return
        }
        user_name = 0 + user_name;
      }
      if (this.user_name.length == 11) {
        if (user_name[0] != '0') {
          this.$message({
            type: 'error',
            message: 'Please check your phone number',
            closable:true
          })
          return
        }
      }

      this.disabledBtn = true;
      axios
        .post(
          `${process.env.VUE_APP_DEFAULT_SRC}send?transaction_id=${this.$route.query.transaction_id}&user_name=${this.user_name}`, {
            transaction_id: this.$route.query.transaction_id,
            user_name
          }
        )
        .then(res => {
          this.disabledBtn = false;
          let code = res.data.code;
          let type = {
            '20005': 'The order is not exists', // The order is not exists.
            '20012': "The order is expired.", //  The order is not expired.
            '20013': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20000': "Something went wrong, contact us please.", // Something went wrong, contact us please.
            '20014': "The order is completed.", // The order is completed.
          }
          if (code == 0) {
            window.location.href = res.data.data.view_url;
            this.order = res.data.data;
          } else {
            this.$message({
              type: 'error',
              message: type[code],
              closable:true
            })
            this.timeMsg = type[code];
            this.showAlert = false
          }
        }).catch(() => {
          this.disabledBtn = false;
        });
    }
  },
  updated(){
    document.title = 'cashier'
  },
  created() {
    document.title = 'cashier'
    this.getOrder();
    // this.timeout = setInterval(() => this.getOrder(), 10000);
  }
};
</script>
<style lang="scss" scoped>
input {
  background-color: rgb(238,238,238);
  height: 40px;
  border: none;
  color:black
}
button {
  background-color: #007bff;
  color:white
}
.modalTitle{
  color:black !important
}
  .account_name{
    word-break: break-all;
  }
  .timeMsg{
    height: 90vh;
    display: flex;
    align-items: center;
    h4 {
      text-align: center;
    }
  }
  .alertWrap {
    .alert {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .btn {
      margin-top: auto;
    }
    }
  }
</style>

<style lang="scss">
body {
  background-color: #fff !important;
}

.clickMov {
  background-color: yellow;
  color: rgb(34, 34, 113);
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    text-decoration: underline
  }
}

.video-js {
  width: 375px;
  height: 400px;
  position: relative;
  background-color: transparent !important;
}

.vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%);
}

.modalWrap {
  position: relative;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;

  // display: flex;
  // justify-content: center;
  // align-items: center;
  .close {
    position: absolute;
    right: 10px;
    top: 20px;
    z-index: 999;
    color: white;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    border-radius: 50%;
    cursor: pointer;
  }
}

.videoWrap {}
</style>
